export const addressType = {
  billing: 1,
  visiting: 2,
  postal: 3,
  delivery: 4,
  temporary: 5,
};
